import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Table, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { kedoGet, kedoPost } from './kedoApi';

const KedoCounterpartiesPage = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const load = async () => {
        setLoading(true);
        try {
            setRows((await kedoGet('/counterparties')) || []);
        } catch (e) {
            message.error(e?.response?.data?.message || e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const onCreate = async values => {
        try {
            await kedoPost('/counterparties', values);
            message.success('Контрагент добавлен');
            setOpen(false);
            form.resetFields();
            load();
        } catch (e) {
            message.error(e?.response?.data?.message || e.message);
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 16
                }}
            >
                <h1 style={{ margin: 0, fontFamily: 'Georgia, serif' }}>
                    Контрагенты B2B
                </h1>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpen(true)}
                >
                    Пригласить / добавить
                </Button>
            </div>
            <div className="kedo-panel">
                <Table
                    rowKey="id"
                    loading={loading}
                    dataSource={rows}
                    columns={[
                        { title: 'ID', dataIndex: 'id', width: 70 },
                        { title: 'Название', dataIndex: 'name' },
                        { title: 'ИНН', dataIndex: 'inn', width: 140 },
                        { title: 'Email', dataIndex: 'email' },
                        { title: 'Статус', dataIndex: 'status', width: 120 }
                    ]}
                />
            </div>
            <Modal
                title="Контрагент"
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => form.submit()}
                destroyOnClose
            >
                <Form layout="vertical" form={form} onFinish={onCreate}>
                    <Form.Item name="name" label="Название" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="inn" label="ИНН">
                        <Input />
                    </Form.Item>
                    <Form.Item name="email" label="Email приглашения">
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default KedoCounterpartiesPage;
